// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-index-tsx" + "-" + "f31b376f394fc7bbcec2" + ".js";
};